import { render } from "./ChangePassword.vue?vue&type=template&id=4ec9ba6f"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Settings/Account/ChangePassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ec9ba6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ec9ba6f', __exports__)) {
    api.reload('4ec9ba6f', __exports__)
  }
  
  module.hot.accept("./ChangePassword.vue?vue&type=template&id=4ec9ba6f", () => {
    api.rerender('4ec9ba6f', render)
  })

}


export default __exports__